(function (angular) {
	'use strict';

	angular.module('serviceLevelCardModule', [
		'localStorageModule',
		'urlModule'
	]);
})(window.angular);